import React from 'react';
import { Loader, BaasicTable, BaasicHeader, BaasicDropdown } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const UserListTemplate = ({
	t,
	viewStore,
	viewStore: {
		listStore,
		tableData,
		queryUtility,
		isSuperAdmin,
		organizationDropdownStore,
		isSmartshipWarehouseAdministrator,
	},
	headerCell,
	actions,
}) => {
	if (viewStore.loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader title="MAINMENU.ADMINISTRATION.USERS">
				{(isSuperAdmin || isSmartshipWarehouseAdministrator) && (
					<BaasicDropdown
						dropdownStore={organizationDropdownStore}
						isClearable={true}
						className="w--200--px"
						placeholder={t('PLACEHOLDER.ORGANIZATION')}
					/>
				)}
			</BaasicHeader>
			<BaasicTable
				{...{
					listStore,
					tableData,
					queryUtility,
					viewStore,
					headerCell,
					actions,
				}}
				data={listStore.data.slice()}
			/>
		</section>
	);
};

export default defaultTemplate(UserListTemplate);
